(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["EXP-Masterclass"] && !Shopify.designMode) return;
  try {
    
    function initMasterclassBanner(container) {
    const stickyElement = container.querySelector('[data-sticky-element]');
    if (!stickyElement) return;

    const elementHeight = stickyElement.offsetHeight;
    stickyElement.style.width = '100%';

    function applyMobileFontSizes() {
        if (window.innerWidth < 800) {
        container.querySelectorAll('[data-mobile-font]').forEach(el => {
            const mobileSize = el.getAttribute('data-mobile-font');
            if (mobileSize) {
            el.style.fontSize = `${mobileSize}px`;
            }
        });
        }
    }

    function updateStickyPosition() {
        const containerRect = container.getBoundingClientRect();
        const containerTop = containerRect.top;
        const containerBottom = containerRect.bottom;
        const viewportHeight = window.innerHeight;

        if (containerTop < viewportHeight && containerBottom > 0) {
        const visibleTop = Math.max(0, containerTop);
        const visibleBottom = Math.min(containerBottom, viewportHeight);
        const visibleHeight = visibleBottom - visibleTop;

        if (containerBottom < viewportHeight) {
            stickyElement.style.position = 'absolute';
            stickyElement.style.bottom = '0';
            stickyElement.style.top = 'auto';
            stickyElement.style.left = '0';
            stickyElement.style.width = '100%';
        } else if (visibleHeight > elementHeight) {
            stickyElement.style.position = 'fixed';
            stickyElement.style.bottom = '0';
            stickyElement.style.top = 'auto';
            stickyElement.style.left = containerRect.left + 'px';
            stickyElement.style.width = container.offsetWidth + 'px';
        } else {
            stickyElement.style.position = 'absolute';
            stickyElement.style.bottom = '0';
            stickyElement.style.top = 'auto';
            stickyElement.style.left = '0';
            stickyElement.style.width = '100%';
        }
        }
    }

    updateStickyPosition();
    applyMobileFontSizes();

    window.addEventListener('scroll', updateStickyPosition);
    window.addEventListener('resize', () => {
        updateStickyPosition();
        applyMobileFontSizes();
    });
    }

    function initAllMasterclassBanners() {
    const stickyContainers = document.querySelectorAll('[data-sticky-container]');
    stickyContainers.forEach(initMasterclassBanner);
    }

    document.addEventListener('DOMContentLoaded', initAllMasterclassBanners);

    // --- Shopify Theme Editor compatibility ---
    document.addEventListener('shopify:section:load', initAllMasterclassBanners);
    document.addEventListener('shopify:section:select', initAllMasterclassBanners);

  } catch(e) { console.error(e); }
})();
})();
